import { render, staticRenderFns } from "./ProductGroupList.vue?vue&type=template&id=d0d543a2&scoped=true&"
import script from "./ProductGroupList.vue?vue&type=script&lang=js&"
export * from "./ProductGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d543a2",
  null
  
)

export default component.exports